<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @cancel="handleCancel"
    :fullscreen="true"
    cancelText="关闭">

    <template slot="footer">
      <a-button key="cancel" @click="handleCancel">关闭</a-button>
    </template>

    <page-layout :title="'单号：' + model.orderCode"
                 logo="https://gw.alipayobjects.com/zos/rmsportal/nxkuOJlFJuAUhzlMTCEe.png">

      <detail-list slot="headerContent" size="small" :col="2" class="detail-layout">
        <detail-list-item term="渠道">{{ model.orderChanner_dictText }}</detail-list-item>
        <detail-list-item term="渠道单号">{{ model.channelOrderCode }}</detail-list-item>
        <detail-list-item term="订单类型">{{ model.orderType_dictText }}</detail-list-item>
        <detail-list-item term="订单来源">{{ model.orderSource }}</detail-list-item>
        <detail-list-item term="门店">{{ model.storeId_dictText }}</detail-list-item>
        <detail-list-item term="下单时间">{{ model.orderCreatetime }}</detail-list-item>
        <detail-list-item term="付款时间">{{ model.orderPaytime }}</detail-list-item>
        <detail-list-item term="支付方式">{{ model.paymentType }}</detail-list-item>
        <detail-list-item term="支付方式名称">{{ model.orderPayModeName }}</detail-list-item>
        <detail-list-item term="取餐时间">{{ model.orderTakeTime }}</detail-list-item>
<!--        <detail-list-item term="是否配送">{{ model.isDelivery_dictText }}</detail-list-item>-->
        <detail-list-item term="订单备注">{{ model.orderRemark }}</detail-list-item>
      </detail-list>
      <a-row slot="extra" class="status-list">
        <a-col :xs="12" :sm="12">
          <div class="text">状态</div>
          <div class="heading" v-bind:style="{color: this.orderStateColor}">{{ model.orderState_dictText }}</div>
        </a-col>
        <a-col :xs="12" :sm="12">
          <div class="text">订单金额</div>
          <div class="heading">¥ {{ model.orderTotalprice }}</div>
          <div>商品合计: ¥ {{ this.totalMount }}</div>
          <div>商品实收: ¥ {{ model.orderBusinessAmount }}</div>
          <div>折扣: ¥ {{ model.orderDiscount }}</div>
          <div>优惠: ¥ {{ model.orderAdditional }}</div>
          <div>运费: ¥ {{ model.orderDeliveryprice }}</div>
        </a-col>
      </a-row>
      <!-- actions -->
<!--      <template slot="action">-->
<!--        <a-button-group style="margin-right: 10px;">-->
<!--          <a-button type="primary" @click="handleAcceptOrder" :disabled="model.orderState != 'have_paid'">接单</a-button>-->
<!--          <a-button :disabled="model.orderState == 'created'">打票</a-button>-->
<!--        </a-button-group>-->
<!--        <a-button type="danger" @click="handleCancelOrder" :disabled="model.orderState == 'canceling' || model.orderState == 'canceled'">取消-->
<!--        </a-button>-->
<!--      </template>-->

      <a-card :bordered="false" title="订单进度">
        <a-steps :direction="isMobile() && 'vertical' || 'horizontal'" :current="this.orderRate" progressDot>
          <a-step title="待付款"></a-step>
          <a-step title="已付款"></a-step>
          <a-step title="制作中"></a-step>
          <a-step title="配送中/自取中"></a-step>
          <a-step title="完成"></a-step>
        </a-steps>
      </a-card>

      <a-card style="margin-top: 5px" :bordered="false" title="客户信息">
        <detail-list>
          <detail-list-item term="客户姓名">{{ model.consumerName }}</detail-list-item>
          <detail-list-item term="客户电话">{{ model.consumerPhone }}</detail-list-item>
          <detail-list-item term="收件地址">{{ model.deliveryAddress }}</detail-list-item>
        </detail-list>
      </a-card>

      <a-card style="margin-top: 5px" :bordered="false" title="配送信息">
        <detail-list>
          <detail-list-item term="配送方">{{ model.orderDeliver }}</detail-list-item>
          <detail-list-item term="配送费用">{{ model.orderDeliveryprice }}</detail-list-item>
          <detail-list-item term="物流单号">{{ model.orderDeliverId }}</detail-list-item>
        </detail-list>
      </a-card>

      <a-card type="inner" title="订单商品">
        <a-list item-layout="vertical" size="large" :data-source="this.relPublishProdsData">
          <a-list-item slot="renderItem" key="index" slot-scope="item, index">
            <a-row>
              <a-col :xs="24" :sm="8">
                <div>商品名称: {{ item.publishProdName }}</div>
                <div>商品描述: {{ item.publishProdDescription }}</div>
              </a-col>
              <a-col :xs="24" :sm="8">
                <a-list item-layout="vertical" size="large">
                  <a-list-item style="padding:0" v-for="(spec,sindex) in orderSpecFilter(orderSpecListData,item.id)"
                               :key="sindex">
                    <span class="specListItemSpan">{{ spec.specName }}:{{ spec.specValue }}</span>
                    <span class="specListItemSpan">数量:{{ spec.specCount }}</span>
                    <span class="specListItemSpan">单价:{{ spec.specPrice }}</span>
                    <span class="specListItemSpan">属性:{{ buildPropDesc(spec.propList) }}</span>
                  </a-list-item>
                </a-list>
              </a-col>
              <a-col :xs="24" :sm="8">
                <span style="padding:15px">小计: {{ sumProdTotalMount(item.id) }} 元</span>
              </a-col>
            </a-row>
            <div slot="extra">
              <img
                width="272"
                alt="logo"
                :src="getImgView(item.publishPic)"
              />
            </div>
            {{ item.publishProdName }}
          </a-list-item>
          <!--          <a-divider v-if="i!=relPublishProdsData.length-1" style="margin: 16px 0"/>-->
        </a-list>
      </a-card>

      <!--    <a-card style="margin-top: 24px" :bordered="false" title="用户近半年来电记录">-->
      <!--      <div class="no-data"><a-icon type="frown-o"/>暂无数据</div>-->
      <!--    </a-card>-->

      <!-- 操作 -->
<!--      <a-card-->
<!--        style="margin-top: 24px"-->
<!--        :bordered="false"-->
<!--        :tabList="tabList"-->
<!--        :activeTabKey="activeTabKey"-->
<!--        @tabChange="(key) => {this.activeTabKey = key}"-->
<!--        v-if="false"-->
<!--      >-->
<!--        <a-table-->
<!--          v-if="activeTabKey === '1'"-->
<!--          :columns="operationColumns"-->
<!--          :dataSource="operation1"-->
<!--          :pagination="false"-->
<!--        >-->
<!--          <template-->
<!--            slot="status"-->
<!--            slot-scope="status">-->
<!--            <a-badge :status="status | statusTypeFilter" :text="status | statusFilter"/>-->
<!--          </template>-->
<!--        </a-table>-->
<!--        <a-table-->
<!--          v-if="activeTabKey === '2'"-->
<!--          :columns="operationColumns"-->
<!--          :dataSource="operation2"-->
<!--          :pagination="false"-->
<!--        >-->
<!--          <template-->
<!--            slot="status"-->
<!--            slot-scope="status">-->
<!--            <a-badge :status="status | statusTypeFilter" :text="status | statusFilter"/>-->
<!--          </template>-->
<!--        </a-table>-->
<!--        <a-table-->
<!--          v-if="activeTabKey === '3'"-->
<!--          :columns="operationColumns"-->
<!--          :dataSource="operation3"-->
<!--          :pagination="false"-->
<!--        >-->
<!--          <template-->
<!--            slot="status"-->
<!--            slot-scope="status">-->
<!--            <a-badge :status="status | statusTypeFilter" :text="status | statusFilter"/>-->
<!--          </template>-->
<!--        </a-table>-->
<!--      </a-card>-->

    </page-layout>
  </j-modal>
</template>

<script>
import {mixinDevice} from '@/utils/mixin.js'
import PageLayout from '@/components/page/PageLayout'
import DetailList from '@/components/tools/DetailList'
import {getAction, getFileAccessHttpUrl, postAction} from "@/api/manage";

const DetailListItem = DetailList.Item

let totalMountProd = 0.00

export default {
  name: "SalesOrderDetailModal",
  components: {
    PageLayout,
    DetailList,
    DetailListItem
  },
  mixins: [mixinDevice],
  data() {
    return {
      tabList: [
        {
          key: 'order_tracelog',
          tab: '订单跟踪'
        },
        // {
        //   key: '2',
        //   tab: '操作日志二'
        // },
        // {
        //   key: '3',
        //   tab: '操作日志三'
        // }
      ],
      activeTabKey: '1',
      title: "订单详情",
      width: 800,
      visible: false,
      relPublishProdsData: [],
      totalMount: 0.00,
      model: {
        orderCode: '',
        channelOrderCode: '',
        consumerName: '',
        consumerPhone: '',
        couponName: '',
        couponPrice: 0,
        createBy: '',
        createTime: '',
        deliveryAddress: '',
        orderSource:'',
        id: '',
        paymentType: '',
        isCoupon: '',
        isDelivery: -1,
        isDelivery_dictText: '',
        isOnsale: -1,
        orderChanner: '',
        orderChanner_dictText: '',
        orderCreatetime: '',
        orderDeliveryprice: 0,
        orderOriginalprice: 0,
        orderBusinessAmount: 0,
        orderPaytime: '',
        orderState: -1,
        orderState_dictText: '',
        orderStorecontact: '',
        storeId: '',
        storeId_dictText: '',
        orderStoreowner: '',
        orderTotalprice: 0,
        orderUserprice: 0,
        relPublishids: '',
        saleContext: '',
        salePrice: 0,
        updateBy: '',
        updateTime: '',
        orderRemark: '',
        orderSpecList: '',
        orderType: '',
        orderType_dictText: '',
        orderTakeTime: '',
        orderDeliver: '',
        orderDeliverId: '',
        orderPayModeName: '',
        orderDiscount: '',
        orderAdditional: '',
      },
      url: {
        queryRelPublishProds: "/sales/salesPublishList/queryByIds",
        acceptOrder: "/sales/salesOrder/accept",
        cancelOrder: "/sales/salesOrder/cancel"
      },
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        'agree': '成功',
        'reject': '驳回'
      }
      return statusMap[status]
    },
    statusTypeFilter(type) {
      const statusTypeMap = {
        'agree': 'success',
        'reject': 'error'
      }
      return statusTypeMap[type]
    }
  },
  computed: {
    orderRate: function () {
      switch (this.model.orderState) {
        case "created":
          return 0
        case "have_paid":
          return 1
        case "accepted":
          return 2
        case "delivery":
          return 3
        case "completed":
          return 4
        case "canceling":
          return 5
        case "canceled":
          return 6
        default:
          return 0
      }
    },
    orderStateColor: function () {
      switch (this.model.orderState) {
        case "created":
          return 'green'
        case "have_paid":
          return 'blue'
        case "accepted":
          return 'green'
        case "completed":
          return '#FF8D1A'
        case "canceling":
          return 'red'
        case "canceled":
          return 'red'
        default:
          return 'green'
      }
    },
    orderSpecListData: function(){
      return JSON.parse(this.model.orderSpecList)
    }
  },
  updated() {
    this.$nextTick(() => {
      // 隐藏面包屑组件
      let breadcrumbEl = document.getElementsByClassName('breadcrumb')[0]
      if (breadcrumbEl) {
        breadcrumbEl.remove()
      }
      this.totalMount = Math.round(totalMountProd * 100) / 100
    })
  },
  methods: {
    resetValues(){
      this.relPublishProdsData = []
      totalMountProd = 0.00
    },
    detail(record) {
      this.resetValues()
      this.visible = true
      this.model = Object.assign({}, record)
      let param = {ids: this.model.relPublishids}
      this.$nextTick(()=>{
        getAction(this.url.queryRelPublishProds, param).then(res => {
          if (res.success && res.result) {
            this.relPublishProdsData = res.result
          }
        })
      })
    },
    handleCancel() {
      this.visible = false
    },
    orderSpecFilter(orderSpecList, publishProdId) {
      let resultArray = []
      orderSpecList.forEach(item => {
        if (item.publishProdId == publishProdId) {
          resultArray = item.specList
        }
      })
      return resultArray
    },
    sumProdTotalMount(publishProdId) {
      let specList = this.orderSpecFilter(this.orderSpecListData, publishProdId)
      let sumMount = 0.00
      specList.forEach(spec => {
        sumMount = sumMount + (spec.specCount * parseFloat(spec.specPrice))
      })
      totalMountProd = totalMountProd + sumMount
      return Math.round(sumMount * 100) / 100
    },
    buildPropDesc(propList) {
      let desc = ''
      propList.forEach(prop => {
        desc = desc + '[' + prop.propName + ':' + prop.propValue + '];'
      })
      return desc
    },
    /* 图片预览 */
    getImgView(text) {
      if (text && text.indexOf(",") > 0) {
        text = text.substring(0, text.indexOf(","))
      }
      return getFileAccessHttpUrl(text)
    },
    handleAcceptOrder(){
      postAction(this.url.acceptOrder, {id:this.model.id}).then((res)=>{
        if(res.success){
          this.model = Object.assign({},res.result)
          this.detail(this.model)
        }else{
          that.$message.error(res.message);
        }
      })
    },
    handleCancelOrder(){
      postAction(this.url.cancelOrder, {id:this.model.id}).then((res)=>{
        if(res.success){
          this.model = Object.assign({},res.result)
          this.detail(this.model)
        }else{
          that.$message.error(res.message);
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>

.detail-layout {
  margin-left: 44px;
}

.text {
  color: rgba(0, 0, 0, .45);
}

.heading {
  color: rgba(0, 0, 0, .85);
  font-size: 20px;
}

.no-data {
  color: rgba(0, 0, 0, .25);
  text-align: center;
  line-height: 64px;
  font-size: 16px;

  i {
    font-size: 24px;
    margin-right: 16px;
    position: relative;
    top: 3px;
  }
}

.mobile {
  .detail-layout {
    margin-left: unset;
  }

  .text {

  }

  .status-list {
    text-align: left;
  }
}

.ant-btn-danger {
  background-color: #ff4d4f;
}

.prodPic {
  width: 25%;
}

.specListItemSpan {
  margin-left: 10px;
}
</style>